// export const BaseUrl = `http://localhost:8000`
export const BaseUrl = `https://jabcomp.gy/gyaddr/api/v1/location`